import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Vg360Component } from './Vg360.Component';
import { VBrick360UtilService } from './VBrick360Util.Service';

const components = [
	Vg360Component
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule
	],
	providers: [
		VBrick360UtilService
	]
})
export class VBrickPlayer360PluginModule {}
